module.exports = __webpack_public_path__ + "img/distance-blue.538ac6d5.svg";